import api from '@/ts/api';
import tools from '@/ts/tools';
import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

export const Assets = defineStore('assets', {
  state: () => ({
    cache: useStorage('stima_assets', []),
    // types: useStorage('stima_types', []), //attr field type    
    
    db: [],    
    // rootlist: [],    
    stats: [],
  }),
  
  getters: {   
    
  },
  
  actions: {
   
   async guess(files){
          console.log("guess files", files)
          if (!files) return
          if (!files.length) return
          let file = files[0]
          console.log("guess file", file)
          let body = await tools.readFileAsBase64(file)
          console.log("guess body", body.lenght )
          let res = await api.send('assets/guess', {image: body})          
          if (res.error) {
            console.log("guess error", res.error )
            return
          }
          console.log("guess done", res.resp )
          window.location = `/assets/${res.resp.id}`
   },
   
   async search(q){
        let res = await api.send('admin/assets/search',q)
        if (res.error) {
          console.error(res.error)
          return []
        }
        return res.resp || []
   },
   
   async list(type, limit, offset){
        let res = await api.send('admin/assets/search',{type, limit, offset})
        if (res.error) {
          console.error(res.error)
          return []
        }
        return res.resp || []
   },

   
      
    async update(id, k, v){
        let res = await api.send('admin/assets/update',{id, k, v})
        if (res.error) return res        
        return res
    },
    
    async updateMeta(id, k, v){
        let res = await api.send('admin/assets/update/meta',{id, k, v})
        if (res.error) return res        
        return res
    },

      async delete(id){
        let res = await api.send('admin/assets/delete',{id})
        if (res.error) return res              
        return res
    },

     
  },



})

